import { render } from "./MenuBrands.vue?vue&type=template&id=f1bf7382&lang=pug"
import script from "./MenuBrands.vue?vue&type=script&lang=js"
export * from "./MenuBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__